import { Button, Center, Container, NavLink, Stack, Text, Title, Group, Box, SimpleGrid, createStyles, Card, Paper, Image } from '@mantine/core';
import { IconInfoCircle, IconLink, IconMail, IconMap, IconNotebook, IconPhone } from '@tabler/icons-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import OBRCLogo from '../assets/images/OBRC_OBD CLR.png'

const useStyles = createStyles((theme) => ({
  textWithIcon: {
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
  }
}));

const Home = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  return (
    <Container>
      <Center>
        <Stack spacing='xl'>
          <Image src={OBRCLogo} alt='Oregon Beverage Recycling Cooperative' width={150} mx='auto' />
          <Title align='center' order={3}>OBRC Container Registration Portal</Title>  
          <Card shadow='sm' padding='lg' radius='md' withBorder position='center' mt={10}>
            <Stack align='center'>
              <Text fz="md" align='center'>
                Under the Oregon Bottle Bill, <a href="https://olis.oregonlegislature.gov/liz/2019R1/Downloads/MeasureDocument/SB914/Enrolled">ORS 459A.718 <IconLink size={"0.8rem"} /></a> requires Oregon Beverage Recycling Cooperative (OBRC) to maintain a registry of all types of beverage containers sold and redeemed in the state of Oregon. Starting January 1st, 2020, all distributors or importers are required to register their beverage containers with OBRC every calendar year using data from the previous year. OLCC may impose civil and criminal penalties if their beverage containers are not registered with OBRC. 
              </Text>
              <Button onClick={() => navigate('/faq')}>LEARN MORE ABOUT ORS 495A.718</Button>
            </Stack>
          </Card>
          <Card shadow='sm' padding='md' radius='md' withBorder position='center' mt={10}>
            <Text fz="md" align='center'>To determine if your beverage product is subject to Oregon's Bottle Bill Law, please visit <a href='https://www.oregon.gov/OLCC/pages/bottle_bill.aspx'>OLCC's Website <IconLink size={"0.8rem"} /></a>.</Text>
          </Card>
          <SimpleGrid cols={2} >
            <Card maw={500} shadow='sm' padding='lg' radius='md' withBorder position='center' mt={10}>
              <Center>
                <IconNotebook size={25} color='#228be6' />
              </Center>
              <Title mt={15} align='center' order={4}>Our Mission</Title>
              <Text align='center' mt={10}>OBRC is the industry steward of Oregon’s nationally recognized beverage container deposit program. We help keep Oregon beautiful by providing outstanding services to our 
                partner distributors and retailers, and to the public for the recovery, reuse, and recycling or beverage containers.
              </Text>
            </Card>
            <Card maw={500} shadow='sm' padding='lg' radius='md' withBorder position='center' mt={10}>
              <Center>
                <IconMail size={25} color='#228be6' />
              </Center>
              <Title mt={15} order={4} align='center'>Contact Us</Title>
              <Text align='center' mt={10}>For Beverage Container Registration Inquiries:</Text>
              <Center>
                <a href='mailto:ORBottleBillRegistration@obrc.com'>ORBottleBillRegistration@obrc.com <IconMail size={"0.8rem"} /></a>
              </Center>

              <Text align='center' mt={25}>To Learn More About OBRC Membership:</Text>
              <Center>
                <a href='https://obrc.com/partners/for-distributors/'>Visit Our Website <IconLink size={"0.8rem"} /></a>
              </Center>
            </Card>
          </SimpleGrid>
        </Stack>
      </Center>
    </Container>
  )
}

export default Home;